import { AxiosRequestConfig } from 'axios';
import { useCallback, useEffect, useState } from 'react';

import { ProtectedRequest } from '../services/helper';

export const useApiData = (url: string, config?: AxiosRequestConfig) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any>({ data: null });
  const [error, setError] = useState<unknown>();

  const [currConfig, setCurrConfig] = useState<AxiosRequestConfig | undefined>(
    config
  );
  if (config && JSON.stringify(currConfig) !== JSON.stringify(config)) {
    setCurrConfig(config);
  }
  const fetchFn = useCallback(
    async (
      ignore: { isIgnore: boolean } = { isIgnore: false },
      signal?: AbortSignal
    ) => {
      if (url) {
        try {
          setIsLoading(true);
          setData(null);
          setError(null);
          const res = await ProtectedRequest.get(url, {
            ...currConfig,
            signal: signal,
          });
          if (!ignore.isIgnore) setData(res);
        } catch (error) {
          if (!ignore.isIgnore) setError(error);
          console.error('Api Error💥💥💥', error);
        } finally {
          if (!ignore.isIgnore) setIsLoading(false);
        }
      }
    },
    [url, currConfig]
  );

  useEffect(() => {
    let ignore = { isIgnore: false };
    const controller = new AbortController();
    fetchFn(ignore, controller.signal);
    return () => {
      ignore.isIgnore = true;
      controller.abort();
    };
  }, [fetchFn]);

  return {
    isLoading,
    data: data?.data ?? null,
    res: data,
    setData,
    setIsLoading,
    error,
    reValidate: fetchFn,
  };
};
export default useApiData;
